export default __webpack_public_path__ + "static/media/Close.c477d6f2.svg";